export default __webpack_public_path__ + "static/media/salary_guide_image_1.84366a29.png";